'use client';

import '@ui5/webcomponents/dist/CustomListItem.js';
import { ListItemType } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * A component to be used as custom list item within the `List` the same way as the standard `StandardListItem`. The component accepts arbitrary HTML content to allow full customization.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-List)
 */
const CustomListItem = withWebComponent('ui5-li-custom', ['accessibleName', 'type'], ['navigated', 'selected'], ['deleteButton'], ['detail-click']);
CustomListItem.displayName = 'CustomListItem';
CustomListItem.defaultProps = {
  type: ListItemType.Active
};
export { CustomListItem };